import { gql } from "@apollo/client";

export const KeepAliveQuery = gql`
  query KeepAlive {
    keepAlive {
      message
    }
  }
`;
